import { render } from "./FrequencyWatchHosRow.vue?vue&type=template&id=2a7aeb5d&ts=true"
import script from "./FrequencyWatchHosRow.ts?vue&type=script&lang=ts&external"
export * from "./FrequencyWatchHosRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__